// extracted by mini-css-extract-plugin
export default {"template":"template-iNugX","optionsContainer":"optionsContainer-XFsRy","optionBox":"optionBox-tTpgW","fourOptions":"fourOptions-RjHNh","threeOptions":"threeOptions-qMOrP"};